import React from "react";
import Navbar from '../navBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/md-dark-indigo/theme.css";
import "primereact/resources/primereact.min.css"
import 'primeicons/primeicons.css';
import 'react-slideshow-image/dist/styles.css'
import { useTranslation } from "react-i18next";
import FooterComponent from "../footer";
import "../../style/table.css"
import TableFeldspat from "../feldspatTable";
import { Menu } from "primereact/menu";
import FeldspatMenu from "../feldspatMenu";
import "../../style/commonMobile.css";

const FeldspatKF9201 = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <PrimeReactProvider>
            <Navbar />
            <div className="feldspatContainer">
                <div style={{ display: "block" }}>
                    <FeldspatMenu />
                </div>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}>
                    <TableFeldspat baslik="TEKNOMADEN FELDSPAR (-212+63 MICRON) 99KF9201 TDS" plantAddress="Yeşilköy/Kavaklıdere/Muğla" kod="99KF9201" humidity="0.3" oilAbsorb="" na2o="9.07" k2o="0.34" cao="0.55" fe2o3="0.15" tio2="0.08" al2o3="17.08" mgo="0.10" p2o5="0.24" sio2="72.09" kk="0.30" l="85.70" a="0.62" b="7.93" albit="76.7" ortoklas="2.00" anortit="2.7" kaolinit="2.01" kuvars="16.5" />
                </div>
            </div>
            <FooterComponent />
        </PrimeReactProvider>
    );
}
export default FeldspatKF9201;